export default __webpack_public_path__ + "static/media/roundLogo.f461c935.png";